import React, { FC } from 'react';
import Draggable from 'react-draggable';
import Dragger from '../../../sidebar/views/CreateTask/create_task/dragger';
import styles from './index.module.css';
import modalStyles from '../ModalLayout/index.module.css';
import { X as Close } from 'lucide-react';
import PoweredBy from './PoweredBy';
import { usePublicFeedbackState } from '../../../providers/PublicFeedback';

import CreateTask from './CreateTask';
import PublicLoading from './PublicLoading';
import PublicUploading from './PublicUploading';
import PublicSuccess from './PublicSuccess';
import PublicError from './PublicError';
import cx from 'classnames';
import useStopZoomOnInputs from '../../../sidebar/views/hooks/useStopZoomOnInputs';

type Props = {};

const CreateTaskModal: FC<Props> = () => {
  const {
    containerElement,
    setContainerElement,
    onDragStart,
    onDragStop,
    isDragging,
    onModalClose,
    feedbackState
  } = usePublicFeedbackState();

  useStopZoomOnInputs();

  const OverlayContent = () => {
    switch (feedbackState) {
      case 'LOADING':
        return <PublicLoading />;
      case 'UPLOADING':
        return <PublicUploading />;
      case 'SUCCESS':
        return <PublicSuccess />;
      case 'ERROR':
        return <PublicError />;
      default:
        return null;
    }
  };

  if (feedbackState === 'SELECTOR') return null;

  return (
    <div className={modalStyles.outerContainer} ref={setContainerElement}>
      <Draggable
        handle=".dragWrapper"
        onStart={onDragStart}
        onStop={onDragStop}
      >
        <div>
          <div className={cx(modalStyles.modal, styles.widthOverride)}>
            {containerElement && (
              <Dragger isDragging={isDragging} container={containerElement} />
            )}
            <div className={modalStyles.closeContainer} onClick={onModalClose}>
              <Close className={modalStyles.closeIcon} />
            </div>
            {feedbackState !== 'TASK' && (
              <div className={styles.overlayOuter}>
                <OverlayContent />
              </div>
            )}

            <div className={styles.createTaskOuter}>
              <CreateTask />
            </div>
            <PoweredBy />
          </div>
        </div>
      </Draggable>
    </div>
  );
};

export default CreateTaskModal;
